import React from 'react'
import './MainView.scss'

import HeaderView from '../../../layouts/Header/containers/HeaderContainer'
import ContentView from '../../../layouts/Content/containers/ContentContainer'
import FooterView from '../../../layouts/Footer/containers/FooterContainer'

import TimeoutOverlay from '../../../components/shared/TimeoutOverlay/containers/TimeoutOverlayContainer'
import ErrorOverlay from '../../../components/shared/ErrorOverlay/containers/ErrorOverlayContainer'

import {tryReset} from "../../../components/shared/TimeoutOverlay/modules/timer";

class MainView extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount(){
    const {loadProducts, getUser} = this.props;

    getUser();
    loadProducts();
  }

  render() {
    const {route} = this.props;

    return (
      <div onMouseMove={() => tryReset()}>
        <HeaderView/>
        <ContentView routes={route.routes}/>
        <FooterView/>

        <TimeoutOverlay/>
        <ErrorOverlay />
      </div>
    )
  }
}

export default MainView



// WEBPACK FOOTER //
// ./src/routes/Main/components/MainView.js